import React, { useState } from "react";
import logo from "./logo.png";
export default function Header() {
  return (
    <div className="Header">
      <div className="header-left">
        <img src={logo} height={100} width={100} />
      </div>

      <div className="header-right">
        <div className="search">
          <i class="fas fa-search fa-lg"></i>
        </div>
        <div className="dropdown"></div>
        <div className="userlogo"></div>
      </div>
    </div>
  );
}
